import { createFileRoute } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';
import UserMove from '@/ui/pages/UserMove/UserMove';

export const Route = createFileRoute('/_dashboard/users/$id/$tenantId/move')({
  beforeLoad: requireRoute('/users/$id/$tenantId/move'),
  component: UserMove,
});
